document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-heritage-section]')
  if (!section) return

  const track = section.querySelector('[data-products-track]')
  const nextButton = section.querySelector('[data-products-next]')
  const bars = track ? Array.from(section.querySelectorAll('[data-indicator-bar]')) : []

  if (track) {
    const getStep = () => {
      const card = track.querySelector(':scope > [data-heritage-product]')
      if (!card) return track.clientWidth
      const styles = getComputedStyle(track)
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0
      return card.offsetWidth + gap
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
        const atEnd = track.scrollLeft >= maxScroll - 1

        track.scrollTo({
          left: atEnd ? 0 : Math.min(track.scrollLeft + getStep(), maxScroll),
          behavior: 'smooth',
        })
      })
    }

    if (bars.length) {
      const updateIndicator = () => {
        const step = getStep()
        const index = step ? Math.round(track.scrollLeft / step) : 0
        bars.forEach((bar, i) => {
          bar.classList.toggle('bg-black-200', i === index)
          bar.classList.toggle('bg-black-12', i !== index)
        })
      }

      let ticking = false
      track.addEventListener('scroll', () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
          updateIndicator()
          ticking = false
        })
      })
    }
  }

  const lineInners = section.querySelectorAll('[data-heritage-line]')
  const productsBlock = section.querySelector('[data-heritage-products]')
  const productsIndicator = section.querySelector('[data-products-indicator]')
  const heritageCta = section.querySelector('[data-heritage-cta]')
  const productImages = productsBlock?.querySelectorAll('[data-heritage-product] img')

  const hero = document.querySelector('[data-home-hero-section]')
  const useHeroReveal = hero && !window.theme?.designMode

  gsap.set(lineInners, { yPercent: 120, opacity: 0 })

  if (productsBlock) {
    gsap.set(productsBlock, { y: 40, autoAlpha: 0 })
    if (productImages?.length) gsap.set(productImages, { scale: 1.08 })
  }

  if (productsIndicator) {
    gsap.set(productsIndicator, { y: 40, autoAlpha: 0 })
  }

  if (heritageCta) {
    gsap.set(heritageCta, { y: 20, opacity: 0, visibility: 'hidden' })
  }

  const reveal = () => {
    gsap.to(lineInners, {
      yPercent: 0,
      opacity: 1,
      duration: 0.9,
      ease: 'power3.out',
      stagger: 0.12,
    })

    if (productsBlock) {
      gsap.to(productsBlock, {
        y: 0,
        autoAlpha: 1,
        duration: 1.3,
        ease: 'power3.out',
        delay: 0.15,
      })

      if (productImages?.length) {
        gsap.to(productImages, {
          scale: 1,
          duration: 1.3,
          ease: 'power3.out',
          delay: 0.15,
        })
      }
    }

    if (productsIndicator) {
      gsap.to(productsIndicator, {
        y: 0,
        autoAlpha: 1,
        duration: 1.3,
        ease: 'power3.out',
        delay: 0.15,
      })
    }

    if (heritageCta) {
      gsap.to(heritageCta, {
        y: 0,
        opacity: 1,
        visibility: 'visible',
        duration: 1,
        ease: 'power2.out',
        delay: 0.4,
        onComplete: () => {
          gsap.set(heritageCta, { clearProps: 'opacity' })
        },
      })
    }
  }

  const reset = () => {
    gsap.set(lineInners, { yPercent: 120, opacity: 0 })
    if (productsBlock) {
      gsap.set(productsBlock, { y: 40, autoAlpha: 0 })
      if (productImages?.length) gsap.set(productImages, { scale: 1.08 })
    }
    if (productsIndicator) gsap.set(productsIndicator, { y: 40, autoAlpha: 0 })
    if (heritageCta) gsap.set(heritageCta, { y: 20, opacity: 0, visibility: 'hidden' })
  }

  const createScrollTrigger = () => {
    if (!window.ScrollTrigger) return
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top 75%',
      onEnter: reveal,
    })
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      onLeaveBack: reset,
    })
  }

  const waitForHeroReveal = (heroSection) => {
    const onHeroRevealed = () => {
      reveal()
      createScrollTrigger()
    }

    if (heroSection.hasAttribute('data-hero-revealed')) {
      onHeroRevealed()
      return
    }

    const observer = new MutationObserver(() => {
      if (!heroSection.hasAttribute('data-hero-revealed')) return
      observer.disconnect()
      onHeroRevealed()
    })

    observer.observe(heroSection, { attributes: true, attributeFilter: ['data-hero-revealed'] })
  }

  if (useHeroReveal) {
    waitForHeroReveal(hero)
  } else if (window.ScrollTrigger) {
    createScrollTrigger()
  } else {
    reveal()
  }
})
